import { all } from 'redux-saga/effects'
import watchWebserviceSaga from './webserviceSaga.js'

function* sagas(){
	yield all([
		watchWebserviceSaga()
	])
}
export default sagas;